import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { GetHistoryListDTO } from '@/services/history/service/history.repository.interface';
import { GetHistoryList } from '@/infrastructure/api-functions/interface/get-history-list.interface';
import type { GetHistoryListRequest, GetHistoryListResponse } from '@/services/history/type/history.type';

@injectable()
export class GetHistoryListDTOImpl implements GetHistoryListDTO {
    constructor(
        @inject(GetHistoryList)
        private readonly _getHistoryListApi: GetHistoryList,
    ) { }

    async fetch(data: GetHistoryListRequest): Promise<GetHistoryListResponse> {
        const res = await this._getHistoryListApi.getHistoryList(data);

        const { total_page: totalPage, list = [] } = res;


        return {
            ...res,
            totalPage,
            list: list.map(item => {
                return {
                    taskId: item.task_id,
                    title: item.title,
                    isRead: item.is_read,
                    updatedAt: item.updated_at,
                    taskType: item.task_type,
                    asyncStatus: item.async_status,
                    type: item.type,
                };
            }),
        };
    }
}
